/**
 * AUTO-GENERATED by scripts/generate-module-manifest.ts
 * DO NOT EDIT THIS FILE BY HAND.
 *
 * Run `pnpm gen:modules` after adding, removing, or renaming a
 * module — the scanner picks up `icon: 'Name'` literals in every
 * `modules/*\/index.ts` (top-level + nested navigation items) and
 * re-emits this file with the minimal import list.
 *
 * This file is checked into git so CI and production builds never
 * need to run the generator.
 */

/* eslint-disable */
// prettier-ignore-start

import {
  AlertCircle,
  AlertTriangle,
  ArrowLeftRight,
  ArrowRightLeft,
  Banknote,
  BarChart3,
  Blocks,
  BookMarked,
  BookOpen,
  Bot,
  Building,
  Building2,
  Calculator,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CarFront,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Coins,
  Contact,
  Cpu,
  CreditCard,
  DollarSign,
  DoorOpen,
  FileMinus,
  FileOutput,
  FilePlus,
  FileSignature,
  FileSpreadsheet,
  FileText,
  Gauge,
  Globe,
  Handshake,
  Inbox,
  KeyRound,
  LayoutDashboard,
  ListChecks,
  MapPin,
  Megaphone,
  MessageCircle,
  Network,
  Package,
  PackageCheck,
  PackagePlus,
  Percent,
  PieChart,
  Plug,
  Receipt,
  ReceiptText,
  Repeat,
  RotateCcw,
  Scale,
  Settings,
  Shield,
  Ship,
  ShoppingCart,
  Split,
  Tag,
  Tags,
  Target,
  TrendingUp,
  UserPlus,
  Users,
  UsersRound,
  Van,
  Wallet,
  Warehouse,
  Webhook,
  Wrench,
  XCircle,
  type LucideIcon,
} from 'lucide-react'

/**
 * Icon name string → Lucide component map. Contains only the icons
 * actually referenced by `modules/*\/index.ts`, plus `Blocks` as the
 * universal fallback used by `getModuleIcon()`.
 */
export const generatedIconRegistry: Record<string, LucideIcon> = {
  AlertCircle,
  AlertTriangle,
  ArrowLeftRight,
  ArrowRightLeft,
  Banknote,
  BarChart3,
  Blocks,
  BookMarked,
  BookOpen,
  Bot,
  Building,
  Building2,
  Calculator,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CarFront,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Coins,
  Contact,
  Cpu,
  CreditCard,
  DollarSign,
  DoorOpen,
  FileMinus,
  FileOutput,
  FilePlus,
  FileSignature,
  FileSpreadsheet,
  FileText,
  Gauge,
  Globe,
  Handshake,
  Inbox,
  KeyRound,
  LayoutDashboard,
  ListChecks,
  MapPin,
  Megaphone,
  MessageCircle,
  Network,
  Package,
  PackageCheck,
  PackagePlus,
  Percent,
  PieChart,
  Plug,
  Receipt,
  ReceiptText,
  Repeat,
  RotateCcw,
  Scale,
  Settings,
  Shield,
  Ship,
  ShoppingCart,
  Split,
  Tag,
  Tags,
  Target,
  TrendingUp,
  UserPlus,
  Users,
  UsersRound,
  Van,
  Wallet,
  Warehouse,
  Webhook,
  Wrench,
  XCircle,
}

// prettier-ignore-end
